import { render, staticRenderFns } from "./OrderShippingSelect.vue?vue&type=template&id=233f244f&"
import script from "./OrderShippingSelect.vue?vue&type=script&lang=js&"
export * from "./OrderShippingSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports